exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shopping-basket[data-v-42e213e2]{position:relative}.shopping-basket[data-basketsize][data-v-42e213e2]:after{content:attr(data-basketsize);width:14px;height:14px;border-radius:50%;background-color:#2b5182;color:#fff;position:absolute;bottom:100%;left:100%;font-weight:300;line-height:15px;display:flex;justify-content:center;align-items:center;font-size:10px;padding-bottom:1px;transform:translateX(-8px) translateY(10px)}", ""]);

// exports
